export default __webpack_public_path__ + "static/media/whiteboard1.7e5a215b.png";